import Layout from '../../../components/Layout/Layout'
import axios from 'axios'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../../context/auth'

const AdminPreOrderBookList = () => {
  const navigate = useNavigate()
  const [books, setBooks] = useState([])
  const [auth] = useAuth()

  // Get all pre-books with total orders
  const getAllPreBooks = async () => {
    try {
      const token = auth?.token
      const { data } = await axios.get('/api/v1/admin/prebook/all-books', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      if (data?.success) {
        setBooks(data?.prebooks)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getAllPreBooks()
  }, [])

  const handleViewDetails = (bookId) => {
    navigate(`/admin/pre-order/books/list/details/${bookId}`)
  }
  const handleEditDetails = (bookId) => {
    navigate(`/admin/pre-order/books/edit/${bookId}`)
  }

  return (
    <Layout title={'Pre-books List'}>
      <div className='pt-3 mx-3'>
        <div className='text-end mb-3'>
          <button
            type='button'
            className='btn btn-outline-info btn-sm'
            onClick={() => navigate('/admin/pre-order/books/create')}
          >
            Add New Pre Book
          </button>
        </div>
        <table className='table'>
          <thead>
            <tr>
              <th scope='col'>Title</th>
              <th className='text-center'>Remaining Vol.</th>
              <th className='text-center'>Last Vol.</th>
              <th className='text-center'>Status</th>
              <th className='text-center'>Total Orders</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {books?.map((book, index) => (
              <tr key={index}>
                <td>{book.title}</td>
                <td className='text-center'>{book.vol}</td>
                <td className='text-center'>{book.lastVol}</td>
                <td
                  className='text-center'
                  style={{ color: book.status === 1 ? 'green' : 'grey' }}
                >
                  {book.status === 1 ? 'Active' : 'Inactive'}
                </td>
                <td className='text-center'>{book.totalOrders}</td>
                <td style={{ textAlign: 'right' }}>
                  <button
                    onClick={() => handleEditDetails(book._id)}
                    className='btn btn-outline-primary btn-sm mx-3'
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleViewDetails(book._id)}
                    className='btn btn-outline-success btn-sm'
                  >
                    View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Layout>
  )
}

export default AdminPreOrderBookList
